<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Category"
      @click.native.stop
    >
      <v-select
        v-model="categoryValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        placeholder="Select from list"
        multiple
        :options="categoryOptions"
        :reduce="category => category._id"
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    vSelect,
  },
  props: {
    category: {
      type: [Array, null],
      default: null,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      categoryValue: JSON.parse(JSON.stringify(this.category)) || [],
    }
  },
  watch: {
    category: {
      immediate: true,
      handler(val) {
        this.categoryValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:category', this.categoryValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.categoryValue = []

      this.$emit('update:category', this.categoryValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
